(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var PAD = 12;

    // ── Helpers ───────────────────────────────────────────────────
    function placeAbove(el, triggerRect) {
      // position: fixed, above the trigger, horizontally centred
      el.removeAttribute('hidden'); // needs layout to measure width
      var w  = el.offsetWidth;
      var cx = triggerRect.left + triggerRect.width / 2;
      var lx = Math.max(PAD, Math.min(cx - w / 2, window.innerWidth - w - PAD));
      el.style.left   = lx + 'px';
      el.style.bottom = (window.innerHeight - triggerRect.top + 14) + 'px';
      return lx;
    }

    // ── Share popup ───────────────────────────────────────────────
    var shareBtn = document.querySelector('[data-action="footer-share"]');
    var popup    = shareBtn ? document.getElementById('gaf-share-popup') : null;
    var copyBtn  = popup ? popup.querySelector('[data-share="copy"]') : null;
    var instaBtn = popup ? popup.querySelector('[data-share="instagram"]') : null;
    var copyTimer, shareOpen = false;

    // Portal: move out of .gaf-footer__icons-col which gets will-change:transform
    // from the scroll-reveal animation system — that traps position:fixed children.
    if (popup) document.body.appendChild(popup);

    function buildUrls() {
      var url   = encodeURIComponent(location.href);
      var title = encodeURIComponent(document.title);
      popup.querySelector('[data-share="email"]').href   = 'mailto:?subject=' + title + '&body=' + url;
      popup.querySelector('[data-share="whatsapp"]').href = 'https://wa.me/?text=' + url;
      popup.querySelector('[data-share="facebook"]').href = 'https://www.facebook.com/sharer/sharer.php?u=' + url;
      popup.querySelector('[data-share="x"]').href        = 'https://twitter.com/intent/tweet?url=' + url + '&text=' + title;
    }

    function closePopup() {
      if (!popup) return;
      popup.classList.remove('is-open');
      shareBtn.setAttribute('aria-expanded', 'false');
      shareOpen = false;
      setTimeout(function () { if (!shareOpen) popup.setAttribute('hidden', ''); }, 180);
    }

    function openPopup() {
      closeList();
      buildUrls();
      var r  = shareBtn.getBoundingClientRect();
      var lx = placeAbove(popup, r);
      // point arrow at button centre
      var arrow = popup.querySelector('.gaf-share-popup__arrow');
      if (arrow) {
        arrow.style.left      = (r.left + r.width / 2 - lx) + 'px';
        arrow.style.right     = '';
        arrow.style.transform = 'translateX(-50%)';
      }
      requestAnimationFrame(function () { popup.classList.add('is-open'); });
      shareBtn.setAttribute('aria-expanded', 'true');
      shareOpen = true;
    }

    if (shareBtn && popup) {
      shareBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        shareOpen ? closePopup() : openPopup();
      });

      function showCopied(el) {
        clearTimeout(copyTimer);
        el.classList.add('is-copied');
        copyTimer = setTimeout(function () { el.classList.remove('is-copied'); }, 2000);
      }

      if (copyBtn) {
        copyBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          navigator.clipboard.writeText(location.href).then(function () { showCopied(copyBtn); });
        });
      }

      if (instaBtn) {
        instaBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          navigator.clipboard.writeText(location.href).then(function () {
            showCopied(instaBtn);
            setTimeout(function () { window.open('https://www.instagram.com/', '_blank', 'noopener'); }, 400);
          });
        });
      }
    }

    // ── Locale dropdown ───────────────────────────────────────────
    var localeBtn  = document.querySelector('.gaf-footer__locale-btn');
    var list       = localeBtn ? document.getElementById('gaf-footer-lang-list') : null;
    var localeOpen = false;

    if (list) document.body.appendChild(list);

    function closeList() {
      if (!list) return;
      list.classList.remove('is-open');
      localeBtn.setAttribute('aria-expanded', 'false');
      localeOpen = false;
      setTimeout(function () { if (!localeOpen) list.setAttribute('hidden', ''); }, 180);
    }

    function openList() {
      closePopup();
      placeAbove(list, localeBtn.getBoundingClientRect());
      requestAnimationFrame(function () { list.classList.add('is-open'); });
      localeBtn.setAttribute('aria-expanded', 'true');
      localeOpen = true;
    }

    if (localeBtn && list) {
      localeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        localeOpen ? closeList() : openList();
      });

      list.addEventListener('click', function (e) {
        var optBtn = e.target.closest('.gaf-footer__lang-option');
        if (!optBtn) return;
        var locale = optBtn.getAttribute('data-locale');
        if (!locale) return;
        var input = document.getElementById('gaf-footer-locale-input');
        var form  = document.getElementById('gaf-footer-locale-form');
        if (input && form) { input.value = locale; form.submit(); }
      });
    }

    // ── Shared: outside-click, Escape, scroll ────────────────────
    document.addEventListener('click', function (e) {
      if (shareOpen  && popup && !popup.contains(e.target) && e.target !== shareBtn)  closePopup();
      if (localeOpen && list  && !list.contains(e.target)  && e.target !== localeBtn) closeList();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (shareOpen)  closePopup();
      if (localeOpen) { closeList(); localeBtn.focus(); }
    });

    window.addEventListener('scroll', function () {
      if (shareOpen)  closePopup();
      if (localeOpen) closeList();
    }, { passive: true });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var PAD = 12;

    function placeBelow(el, triggerRect) {
      // position: fixed, below the trigger, horizontally centred
      el.removeAttribute('hidden'); // needs layout to measure width
      var w  = el.offsetWidth;
      var cx = triggerRect.left + triggerRect.width / 2;
      var lx = Math.max(PAD, Math.min(cx - w / 2, window.innerWidth - w - PAD));
      el.style.left = lx + 'px';
      el.style.top  = (triggerRect.bottom + 14) + 'px';
    }

    var localeBtn  = document.querySelector('.gaf-header__locale-btn');
    var list       = localeBtn ? document.getElementById('gaf-header-lang-list') : null;
    var localeOpen = false;

    // Portal: .gaf-header has backdrop-filter, which makes it a containing
    // block for position:fixed descendants — escape to document.body.
    if (list) document.body.appendChild(list);

    function closeList() {
      if (!list) return;
      list.classList.remove('is-open');
      localeBtn.setAttribute('aria-expanded', 'false');
      localeOpen = false;
      setTimeout(function () { if (!localeOpen) list.setAttribute('hidden', ''); }, 180);
    }

    function openList() {
      placeBelow(list, localeBtn.getBoundingClientRect());
      requestAnimationFrame(function () { list.classList.add('is-open'); });
      localeBtn.setAttribute('aria-expanded', 'true');
      localeOpen = true;
    }

    if (localeBtn && list) {
      localeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        localeOpen ? closeList() : openList();
      });

      list.addEventListener('click', function (e) {
        var optBtn = e.target.closest('.gaf-header__lang-option');
        if (!optBtn) return;
        var locale = optBtn.getAttribute('data-locale');
        if (!locale) return;
        var input = document.getElementById('gaf-header-locale-input');
        var form  = document.getElementById('gaf-header-locale-form');
        if (input && form) { input.value = locale; form.submit(); }
      });

      document.addEventListener('click', function (e) {
        if (localeOpen && !list.contains(e.target) && e.target !== localeBtn) closeList();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && localeOpen) { closeList(); localeBtn.focus(); }
      });

      window.addEventListener('scroll', function () {
        if (localeOpen) closeList();
      }, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sliders = document.querySelectorAll('[data-hero-slider]');

  sliders.forEach(function (slider) {
    var track = slider.querySelector('[data-hero-track]');
    var slides = slider.querySelectorAll('[data-slide-index]');
    var dots = slider.querySelectorAll('[data-hero-dot]');
    var prevBtn = slider.querySelector('[data-hero-prev]');
    var nextBtn = slider.querySelector('[data-hero-next]');

    if (!track || slides.length < 2) return;

    var current = 0;
    var isRTL = document.documentElement.dir === 'rtl';
    var autoplay = slider.dataset.autoplay === 'true';
    var speed = parseInt(slider.dataset.autoplaySpeed, 10) || 5000;
    var timer = null;

    function goTo(index) {
      current = ((index % slides.length) + slides.length) % slides.length;
      var offset = isRTL ? current * 100 : -current * 100;
      track.style.transform = 'translateX(' + offset + '%)';

      dots.forEach(function (dot, i) {
        var active = i === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function startAutoplay() {
      if (!autoplay) return;
      timer = setInterval(function () { goTo(current + 1); }, speed);
    }

    function stopAutoplay() { clearInterval(timer); }

    if (prevBtn) prevBtn.addEventListener('click', function () { stopAutoplay(); goTo(current - 1); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stopAutoplay(); goTo(current + 1); startAutoplay(); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        stopAutoplay();
        goTo(parseInt(this.dataset.heroDot, 10));
        startAutoplay();
      });
    });

    slider.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { stopAutoplay(); goTo(isRTL ? current + 1 : current - 1); startAutoplay(); }
      if (e.key === 'ArrowRight') { stopAutoplay(); goTo(isRTL ? current - 1 : current + 1); startAutoplay(); }
    });

    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
